import React from 'react';
import ReactMarkdown from 'react-markdown';

/**
 * Renderuje markdown z pola `explanation` pytania.
 *
 * Wyjaśnienia to krótkie akapity, czasem z listą wypunktowaną - nie ma tu
 * osadzonego HTML-a, więc świadomie nie włączamy rehype-raw. Treść pochodzi
 * z naszej bazy, ale ReactMarkdown i tak nie wykona żadnego skryptu.
 *
 * Normalizujemy długie myślniki na dywiz - obowiązuje w całym serwisie,
 * a treści generowane potrafią je przemycić.
 */
const MarkdownRenderer = ({ content = '' }) => {
  if (!content) return null;
  const tekst = String(content).replace(/[–—]/g, '-');
  return <ReactMarkdown>{tekst}</ReactMarkdown>;
};

export default MarkdownRenderer;
